export type ModuleName = "dill/book"
export const MODULE_NAME: ModuleName = "dill/book"
